import { FC } from 'react';
import FooterBottom from './footer-bottom';
import FooterMegaNav from './footer-meganav';
import FooterNewsletterSignup from './footer-newsletter-signup';
import { megaNav, newsletterCopy, siteIntegrityGroup, socialsGroup } from './types';

export interface AmplienceFooterProps {
  megaNav: megaNav;
  newsletterCopy: newsletterCopy;
  socialsGroup: socialsGroup[];
  siteIntegrityGroup: siteIntegrityGroup[];
}

const AmplienceFooter: FC<AmplienceFooterProps> = ({ newsletterCopy, socialsGroup, megaNav, siteIntegrityGroup }) => {
  return (
    <div data-testid="amplience-footer">
      <div className="py-5" style={{ backgroundColor: '#EFEEE4' }}>
        <FooterNewsletterSignup newsLetterCopy={newsletterCopy} socialsGroup={socialsGroup} />
      </div>
      <FooterMegaNav megaNav={megaNav} />
      <FooterBottom siteIntegrityGroup={siteIntegrityGroup} />
    </div>
  );
};
export default AmplienceFooter;
